import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetPostCardNewsFailed, EGetPostCardNewsActionType } from './types';

export const getPostCardNewsFailed: () => TGetPostCardNewsFailed = actionGenerator<EGetPostCardNewsActionType.Failed>(
  EGetPostCardNewsActionType.Failed,
);
